var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-progress',{staticClass:"rounded-0 position-absolute shadow",class:{ show: _vm.numPendingOperations },attrs:{"id":"loader","value":100,"striped":"","animated":"","variant":"precision"}})
}
var staticRenderFns = []

export { render, staticRenderFns }